'use strict';

export function setGestureState() {
  console.warn('[Reanimated] setGestureState() is not available on web.');
}
//# sourceMappingURL=setGestureState.web.js.map